var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModeDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 26,
    viewBox: "0 0 52 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 1.25,
    width: 50.5,
    height: 23.5,
    rx: 11.75,
    stroke: "#2A945F",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3327 13.0013C17.3327 14.8422 15.8403 16.3346 13.9993 16.3346C12.1584 16.3346 10.666 14.8422 10.666 13.0013C10.666 11.1604 12.1584 9.66797 13.9993 9.66797C15.8403 9.66797 17.3327 11.1604 17.3327 13.0013Z",
    stroke: "#34B474",
    strokeOpacity: 0.5,
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0007 6.33203V7.33203M14.0007 18.6654V19.6654M18.7145 17.7129L18.0074 17.0058M9.99349 8.99154L9.28638 8.28443M20.6673 12.9987H19.6673M8.33398 12.9987H7.33398M18.7149 8.2845L18.0077 8.99161M9.99382 17.0058L9.28671 17.713",
    stroke: "#34B474",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3327 14.3869C43.5329 14.8139 42.6194 15.056 41.6494 15.056C38.4987 15.056 35.9446 12.5019 35.9446 9.3512C35.9446 8.38121 36.1867 7.46776 36.6138 6.66797C33.7778 7.33262 31.666 9.87806 31.666 12.9167C31.666 16.4612 34.5394 19.3346 38.0839 19.3346C41.1226 19.3346 43.668 17.2229 44.3327 14.3869Z",
    stroke: "#34B474",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModeDark);
export default __webpack_public_path__ + "static/media/mode-dark.1a3c2be6ba3822e7e34bff0469193c47.svg";
export { ForwardRef as ReactComponent };